import { render, staticRenderFns } from "./RelationsList.vue?vue&type=template&id=754f0768&scoped=true"
import script from "./RelationsList.vue?vue&type=script&lang=js"
export * from "./RelationsList.vue?vue&type=script&lang=js"
import style0 from "./RelationsList.vue?vue&type=style&index=0&id=754f0768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f0768",
  null
  
)

export default component.exports